/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ForumLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwElEQVR4nNWVO0sDQRDHz0LstNDG6GcQC0EQ7Q+SeVwRZi5B7AIiKthZCIKFpZjPIDaW2toY7EVsTQTBxgeKD1Qkkb3k0Dzu3AukcGDg2Jv5/3ZmZ+8c5z8YsqwCyU3dddkqqVAo9AOrjyT7SHKJLC/I8oQsF8iyFsYRyRyy1pD0EEiOkLWaYX82VpzIByS5ChI7uacrYSywrps113UHjJtnsxYpDiQbZheR4qy1TMYfaYifRsaRlNrFWRbjhLHhP723iwvM8/LjQPrcMwCQbNmIY7cAJD3rLYDNCNoBstnsUH1TUoqKAdaTlhbpm4V4FVgOzB1xkhqwnMeKk1wRyUxi4V8VbMcAyoiaMnHpdHYMWYrAWgHSDwM2VSHqdCzAjCmyvrb1kvQLUafCzwKQ3kf2nXQ7FoIkxx2S9oJ3qClkefjrnIB1IaJFstkxwVM3ALAUbSYMSK7bhsBQoxKY54cbMRXbMQbQiSYAkeSCA2sLllvHcfrqFei7LQBR0WKuWs6HtWwLIMpNJgYAya4tIGxrsgpQU3Ej2uSeLjndWIb9WSC5+3uS9NF184NdQTwvP4osO+Y/DSSfUTe/a0BS+wbnvGTCpePPMAAAAABJRU5ErkJggg==)
 */
export const ForumLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 4h.5v-.5a2.5 2.5 0 0 1 5 0V4h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm4-.5V4h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.58 3.23c.24-.33.15-.86-.24-.96C12.59 2.1 11.8 2 11 2c-4.97 0-9 3.58-9 8 0 1.5.47 2.91 1.28 4.11.14.21.12.49-.06.67l-1.51 1.51A1 1 0 0 0 2.4 18h5.1a.5.5 0 0 0 .49-.5c0-3.17 2-5.82 4.77-6.94.29-.11.42-.45.34-.75A3 3 0 0 1 13 9V5c0-.66.22-1.28.58-1.77ZM18.91 12.98a5.45 5.45 0 0 1 2.18 6.2c-.1.33-.09.68.1.96l.83 1.32a1 1 0 0 1-.84 1.54h-5.5A5.6 5.6 0 0 1 10 17.5a5.6 5.6 0 0 1 5.68-5.5c1.2 0 2.32.36 3.23.98Z"
        className={colorClass}
      />
    </svg>
  );
};
